import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'

import { TRoutes } from '../../shared/const'

import styles from './style.module.scss'

/**
 * Die öffentlichen Seiten als Chips.
 *
 * **Die einzige Stelle, an der die öffentlichen Seiten voneinander wissen.**
 * Wer eine dritte dazustellt, trägt sie hier ein — und sie erscheint in der
 * Kopfleiste wie auf den Anmeldeseiten.
 *
 * Zwei Auftritte, dieselbe Liste:
 *
 * - In der **Kopfleiste** der öffentlichen Seiten ist einer der Punkte der
 *   aktuelle; er steht in Mint, die übrigen schlicht daneben.
 * - Auf den **Anmeldeseiten** ist keiner der aktuelle. Alle schlicht zu setzen
 *   ließe sie wie Textverweise aussehen, deshalb bekommen sie dort eine ruhige
 *   Fläche (`alsChips`) — sie sollen als Weg zurück erkennbar sein, ohne „du
 *   bist hier" zu behaupten.
 *
 * **Der Bericht über die Plattform steht hier bewusst nicht.** Er richtet sich
 * an Entscheider:innen und wird aus dem DaVinciLab-Steckbrief in der Fußzeile
 * geöffnet; in einer Leiste neben „Junior Companies" wäre er falsch einsortiert.
 */

const MENUE = [
	{ to: TRoutes.MAIN, label: 'Junior Companies', exact: true },
	{ to: TRoutes.PUBLIC_COURSE, label: 'Skills4Retail' },
	{ to: TRoutes.PUBLIC_ANNUAL_REPORT, label: 'Junior-Bilanz 2025/26' }
]

export default function PublicMenu({ alsChips, className }) {
	const location = useLocation()

	return (
		<nav className={clsx(styles.menu, className)}>
			{MENUE.map(eintrag => {
				const aktiv = eintrag.exact
					? location.pathname === eintrag.to
					: location.pathname.startsWith(eintrag.to)

				return (
					<Link
						key={eintrag.to}
						to={eintrag.to}
						className={clsx(
							styles.menuItem,
							alsChips && styles.menuItemChip,
							aktiv && styles.menuItemActive
						)}
					>
						{eintrag.label}
					</Link>
				)
			})}
		</nav>
	)
}

PublicMenu.propTypes = {
	// Für Seiten, auf denen keiner der beiden Punkte der aktuelle ist.
	alsChips: PropTypes.bool,
	className: PropTypes.string
}

PublicMenu.defaultProps = {
	alsChips: false
}
